var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "white",
    stroke: "#BDD4C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.758 13.132C7.758 13.692 8.206 14.154 8.794 14.154C9.382 14.154 9.83 13.692 9.83 13.132C9.83 12.572 9.382 12.11 8.794 12.11C8.206 12.11 7.758 12.572 7.758 13.132ZM11.986 6.832C11.986 5.222 10.642 4.018 8.836 4.018C6.96 4.018 5.63 5.362 5.63 7.21H7.254C7.268 6.286 7.94 5.586 8.822 5.586C9.69 5.586 10.32 6.202 10.32 6.958C10.32 7.504 9.956 8.036 9.27 8.554C8.402 9.212 7.926 9.94 7.926 10.598V11.088H9.564V10.752C9.564 10.108 10.292 9.632 10.796 9.184C11.622 8.456 11.986 7.714 11.986 6.832Z",
    fill: "#BDD4C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.1457388a80017bf740bbc96884526cfd.svg";
export { ForwardRef as ReactComponent };